import moment from "moment";

/**
 * Nút đăng ký ở màn chi tiết giải CHUNG (Vòng tròn, Đấu đội, Master, Loại trực tiếp -
 * Swiss và Đấu kép có màn riêng).
 *
 * Đăng ký chỉ khoá theo KHUNG ĐĂNG KÝ, KHÔNG theo ngày bắt đầu giải - cùng luật với màn
 * Swiss và Đấu kép (d331638). Giải một ngày (mở đăng ký, hạn chót, khai mạc cùng một
 * ngày) có ngày bắt đầu là 00:00 của chính ngày đó, nên khoá theo nó là cả ngày hiện
 * "Giải đã bắt đầu" dù hạn chót còn tới 23:59. Bản vá 31/10 chỉ sửa hai màn kia, và
 * màn này giữ nguyên lỗi - đó là lý do luật nằm riêng ở đây, có test.
 *
 * API joinLeague cũng không khoá theo ngày bắt đầu, nên khoá ở đây là chặn một việc
 * máy chủ cho phép.
 */
export type GiaiDeXet = {
  isFinished?: boolean;
  endDateObj?: moment.Moment;
  startRegistrationDateObj?: moment.Moment;
  endRegistrationDateObj?: moment.Moment;
};

export function trangThaiDangKy(
  league: GiaiDeXet,
  { daThamGia, khongDuDieuKien, bayGio = moment() }: { daThamGia: boolean; khongDuDieuKien: boolean; bayGio?: moment.Moment },
): { canRegister: boolean; cta: string } {
  /* Đã có vô địch là đã kết thúc, kể cả chưa tới ngày kết thúc: ngày kết thúc ban tổ
     chức nhập chỉ là dự kiến. Backend trả sẵn cờ này nên màn hình không tự xét lại. */
  const finished = !!league.isFinished || (!!league.endDateObj && bayGio.isAfter(league.endDateObj));
  const beforeReg = !!league.startRegistrationDateObj && bayGio.isBefore(league.startRegistrationDateObj);
  const regClosed = !!league.endRegistrationDateObj && bayGio.isAfter(league.endRegistrationDateObj);

  const canRegister = !daThamGia && !finished && !beforeReg && !regClosed && !khongDuDieuKien;
  const cta = daThamGia
    ? "Đã tham gia"
    : finished
      ? "Giải đã kết thúc"
      : beforeReg
        ? "Chưa mở đăng ký"
        : regClosed
          ? "Đã hết hạn đăng ký"
          : khongDuDieuKien
            ? "Không đủ điều kiện tham gia"
            : "Tham gia ngay";

  return { canRegister, cta };
}
